import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs, 
  Divider,
  Paper,
  Grid,
  Stack,
  NumberInput,
  Box,
  Skeleton,
  Breadcrumbs, 
  Anchor,
  MultiSelect,
  FileButton,
  SimpleGrid,
  Image,
  ActionIcon,
} from "@mantine/core";
import {
  IconPhoto,
  IconSettings,
  IconPhotoCancel,
  IconPhotoPlus,
  IconCircleXFilled,
  IconPhotoX,
  IconX,
  IconPlus,
  IconMinus,
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./BuildConfigUpdate.module.css";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import { useQuery, useMutation, useQueryClient  } from 'react-query';
import { useForm } from '@mantine/form';
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";

import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

export function BuildConfigUpdate() {
    const location = useLocation();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient()
    const { id } = useParams();

    const [imgFile, setImgFile] = useState<any>(null);
    const [previewImg, setPreviewImg] = useState<string | null>(null)

    const [gallery, setGallery] = useState([])
    const [galleryTemp, setGalleryTemp] = useState([])
    const [galleryFile, setGalleryFile] = useState<File | null>(null)
    const [galleryFiles, setGalleryFiles] = useState<File[]>([])
    const [previewGallery, setPreviewGallery] = useState<any[]>([])


    const form = useForm({
        initialValues: {
            title: "",
            
            cpu: "",
            cooler: "",
            gpu: "",
            mobo: "",
            case: "",
            fan: "",
            ram: "",
            psu: "",
            ssd1: "",
            ssd2: "",
            os: "",
            priceAdmin: 0,
            show: false,

            category: "",
        },

        validate: {
            title: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),

            cpu: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            cooler: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            gpu: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            mobo: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            case: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            ram: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            psu: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            ssd1: (value) => (value.trim().length < 1 ? 'Please select value' : null),
            priceAdmin: (value) => {
                if (isNaN(value)) return 'Price must be a number';  // Number check
                if (value <= 0) return 'Invalid value'; // Positive check
                if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {  // Max 2 decimals
                    return 'Price can only have up to 2 decimals';
                }
                return null;
                },
            category: (value) => (location.pathname.split("/")[1] === 'build-config-prebuild' ? value.trim().length < 1 ? 'Please select value' : null : null),
        },
    });

    useEffect(() => {
        if (!galleryFile) {
            // setPreview(null)
            return
        }

        const objectUrl = URL.createObjectURL(galleryFile)
        setGalleryFiles((prev) => [...prev, galleryFile])
        setPreviewGallery((prev) => [...prev, objectUrl])

        return () => URL.revokeObjectURL(objectUrl)
    }, [galleryFile])

    const onClickRemoveImage = (index: number) => {
        const copy = [...previewGallery];
        const copy2 = [...galleryFiles]
        copy.splice(index, 1)
        copy2.splice(index, 1)
        setPreviewGallery(copy)
        setGalleryFiles(copy2)
    }

    const onClickRemoveImageTemp = (index: number) => {
        const copy = [...galleryTemp];
        copy.splice(index, 1)
        setGalleryTemp(copy)
    }

    const getBuildQuery = useQuery(
        "getBuildQuery",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/build-config/read-by-id", { buildId: id }, { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                // console.log(res)
                form.setValues({...res, 
                    cpu: res.cpu.toString(),
                    cooler: res.cooler.toString(),
                    gpu: res.gpu.toString(),
                    mobo: res.mobo.toString(),
                    case: res.case.toString(),
                    ram: res.ram.toString(),
                    psu: res.psu.toString(),
                    ssd1: res.ssd1.toString(),
                    ssd2: res.ssd2 ? res.ssd2.toString() : '',
                    fan: res.fan ? res.fan.toString() : '',
                    os: res.os ? res.os.toString() : '',
                })

                setGallery(JSON.parse(res.images ? res.images : '[]'))
                setGalleryTemp(JSON.parse(res.images ? res.images : '[]'))
            },
            onError: () => {

            }
        }
    );


    const getPCComponentQuery = useQuery(
        "getPCComponentQuery",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/pc-components/get-item-selection", { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                // console.log(res)
            },
            onError: () => {

            }
        }
    );


    const updateBuildMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/build-config/update", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                queryClient.invalidateQueries({ queryKey: ['getBuildQuery'] })
                setGallery([])
                setGalleryTemp([])
                setGalleryFile(null)
                setGalleryFiles([])
                setPreviewGallery([])
                showSuccessAlert("Build Successfully Updated");
            },
            onError:(err: any) => {
                // setAddRebateFormVisible(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

    const handleUpdateChanges = (data: any) => {
        // console.log(data)
        const formData = new FormData();

        formData.append('buildId', data.buildId);
        formData.append('title', data.title);
        formData.append('cpu', data.cpu);
        formData.append('cooler', data.cooler);
        formData.append('gpu', data.gpu);
        formData.append('mobo', data.mobo);
        formData.append('case', data.case);
        if(data.fan){
            formData.append('fan', data.fan);
        }
        formData.append('ram', data.ram);
        formData.append('psu', data.psu);
        formData.append('ssd1', data.ssd1);
        // formData.append('ssd2', data.ssd2);
        if(data.ssd2){
            formData.append('ssd2', data.ssd2);
        }
        if(data.os){
            formData.append('os', data.os);
        }
        formData.append('priceAdmin', data.priceAdmin);
        
        if(location.pathname.split("/")[1] === 'build-config-prebuild'){
          formData.append('category', data.category);
        }

        formData.append('isPrebuild', location.pathname.split("/")[1] === 'build-config-prebuild' ? '1' : '0');
        formData.append('isCustom', location.pathname.split("/")[1] === 'build-config-custom' ? '1' : '0');
        formData.append('isEasy', location.pathname.split("/")[1] === 'build-config-easy' ? '1' : '0');
        formData.append('show', data.show);
        formData.append('gallery', JSON.stringify(galleryTemp));
        if(previewGallery.length > 0){
            [...galleryFiles].forEach((file, i) => {
                formData.append(`images`, file, file.name)
            })
        }
        else{
            // formData.append(`images`, null)
        }

        updateBuildMutation.mutate(formData)
    }


    useEffect(() => {
        if (!imgFile) {
            setPreviewImg(null)
            return
        }

        const objectUrl = URL.createObjectURL(imgFile)
        setPreviewImg(objectUrl)

        return () => URL.revokeObjectURL(objectUrl)
    }, [imgFile])


  return (
    <div>
        <div>
            <Header title={location.pathname.split("/")[1] === 'build-config-prebuild' ? 'Prebuild PC - Update' : location.pathname.split("/")[1] === 'build-config-custom' ? 'Custom PC Config - Update' : 'Easy Build - Update'} />
            <Breadcrumbs mx={20} my={'sm'}>
                <Anchor component={Link} to={`/${location.pathname.split("/")[1]}`}>
                    {location.pathname.split("/")[1] === 'build-config-prebuild' ? 'Prebuild PC' : location.pathname.split("/")[1] === 'build-config-custom' ? 'Custom PC Config' : 'Easy Build Config'}
                </Anchor>
                <Anchor>
                    Update
                </Anchor>
            </Breadcrumbs>
            <Box
                w={
                    window.innerWidth -
                    document.getElementById("nav-bar")!!.getBoundingClientRect().width
                }
                mt={"md"}
                
            >
                <Paper px={20}>
                    <Grid>
                        <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                            <Skeleton visible={getBuildQuery.isFetching || getBuildQuery.isError} animate={!getBuildQuery.isError}>
                            <form onSubmit={form.onSubmit((values) => handleUpdateChanges(values))}>
                            <Stack gap={'sm'}>
                                <TextInput
                                    label="Name"
                                    placeholder="Input Name"
                                    withAsterisk
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    {...form.getInputProps('title')}
                                />
                                { location.pathname.split("/")[1] === 'build-config-prebuild' ?
                                <Select
                                    label="Category"
                                    placeholder="Select Category"
                                    withAsterisk
                                    data={[
                                      {label: 'Gaming', value: 'gaming'},
                                      {label: 'Creator', value: 'creator'},
                                      {label: 'Office', value: 'office'},
                                      {label: 'AI', value: 'ai'},
                                    ]}
                                    allowDeselect={false}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    {...form.getInputProps('category')}
                                />
                                : null }
                                <div>
                                <Text fw={500} fz={14}>Show Item In Store?</Text>
                                <Checkbox
                                    defaultChecked
                                    label="Show"
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    {...form.getInputProps('show', {type: 'checkbox'})}
                                />
                                </div>
                                <Divider my="xs" label="Product Gallery" labelPosition="center" color="dark.3"/>
                                <div>
                                    <Text fw={500} fz={15}>Current Product Images <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <SimpleGrid cols={4} spacing="xs" verticalSpacing="xs">
                                        {galleryTemp.map((item, i)=>(
                                            <div key={i} style={{position: 'relative'}}>
                                            <Image
                                                key={i}
                                                width={'100%'}
                                                height={'125'}
                                                src={item}
                                                alt="With default placeholder"
                                                // withPlaceholder
                                                fit='cover'
                                            />
                                                <UnstyledButton onClick={()=>onClickRemoveImageTemp(i)} style={{position: 'absolute', top: -10, right: -10, cursor: 'pointer'}} disabled={updateBuildMutation.isLoading}>
                                                    <IconCircleXFilled size={20} style={{color:"#E03131"}}/>
                                                </UnstyledButton>
                                            </div>
                                        ))}
                                        {galleryTemp.length === 0 ?
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',width: '100%', height: 125, backgroundColor: '#E9ECEF'}}>
                                                <IconPhotoX size={35} color={'#868E96'}/>
                                                <Text fz={12}>No image</Text>
                                            </div>
                                        : null}
                                    </SimpleGrid>
                                    { galleryTemp.length !== gallery.length ? 
                                        <Button mt={'md'} onClick={()=>setGalleryTemp(gallery)}  leftSection={<IconX size={18} />} fullWidth color='gray' disabled={updateBuildMutation.isLoading}>Undo Changes</Button>
                                    : null    
                                    }
                                </div>
                                <div>
                                    <Text fw={500} fz={15}>Add Product Images <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <SimpleGrid cols={4} spacing="xs" verticalSpacing="xs">
                                        {previewGallery.map((item, i)=>(
                                            <div key={i} style={{position: 'relative'}}>
                                            <Image
                                                key={i}
                                                width={'100%'}
                                                height={'125'}
                                                src={item}
                                                alt="With default placeholder"
                                                // withPlaceholder
                                                fit='cover'
                                            />
                                                <UnstyledButton onClick={()=>onClickRemoveImage(i)} style={{position: 'absolute', top: -10, right: -10, cursor: 'pointer'}} disabled={updateBuildMutation.isLoading}>
                                                    <IconCircleXFilled size={20} style={{color:"#E03131"}}/>
                                                </UnstyledButton>
                                            </div>
                                        ))}
                                        {previewGallery.length < 8 ?
                                            <FileButton onChange={setGalleryFile} accept="image/png,image/jpeg" disabled={updateBuildMutation.isLoading}>
                                                {(props) => <UnstyledButton {...props} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',width: '100%', height: 125, cursor: 'pointer', backgroundColor: '#E9ECEF'}}>
                                                    <IconPhotoPlus size={35} color={'#868E96'}/>
                                                    <Text fz={12}>Click to add</Text>
                                                </UnstyledButton>}
                                            </FileButton>
                                        : null}
                                    </SimpleGrid>
                                </div>
                                <Divider my="xs" label="PC Components" labelPosition="center" color="dark.3"/>
                                {/* cpu int(11) */}
                                <Select
                                    label="CPU"
                                    placeholder="Select CPU"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.PROCESSOR ? getPCComponentQuery?.data?.PROCESSOR : []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('cpu')}
                                />
                                {/* cooler int(11) */}
                                <Select
                                    label="Cooler"
                                    placeholder="Select Cooler"
                                    withAsterisk
                                    data={[...(getPCComponentQuery?.data?.COOLER || []), ...(getPCComponentQuery?.data?.['WATER COOLING'] || [])]}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('cooler')}
                                />
                                {/* gpu int(11) */}
                                <Select
                                    label="GPU"
                                    placeholder="Select GPU"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.VGA ? getPCComponentQuery?.data?.VGA: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('gpu')}
                                />
                                {/* mobo int(11) */}
                                <Select
                                    label="MOBO"
                                    placeholder="Select MOBO"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.MAINBOARD ? getPCComponentQuery?.data?.MAINBOARD: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('mobo')}
                                />
                                {/* case int(11) */}
                                <Select
                                    label="Case"
                                    placeholder="Select Case"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.CASING ? getPCComponentQuery?.data?.CASING: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('case')}
                                />
                                {/* fan int(11) */}
                                <Select
                                    label="Case Fan"
                                    description="Optional"
                                    placeholder="Select Case Fan"
                                    data={getPCComponentQuery?.data?.FAN ? [{label: 'None', value: ''},...getPCComponentQuery?.data?.FAN]: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('fan')}
                                />
                                {/* ram int(11) */}
                                <Select
                                    label="RAM"
                                    placeholder="Select RAM"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.RAM ? getPCComponentQuery?.data?.RAM: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('ram')}
                                />
                                {/* psu int(11) */}
                                <Select
                                    label="PSU"
                                    placeholder="Select PSU"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.['POWER SUPPLY'] ? getPCComponentQuery?.data?.['POWER SUPPLY']: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('psu')}
                                />
                                {/* ssd1 int(11) */}
                                <Select
                                    label="SSD 1"
                                    placeholder="Select SSD 1"
                                    withAsterisk
                                    data={getPCComponentQuery?.data?.['SSD INT'] ? getPCComponentQuery?.data?.['SSD INT']: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('ssd1')}
                                />
                                {/* ssd2 int(11) */}
                                <Select
                                    label="SSD 2"
                                    description="Optional"
                                    placeholder="Select SSD 2"
                                    data={getPCComponentQuery?.data?.['SSD INT'] ? [{label: 'None', value: ''},...getPCComponentQuery?.data?.['SSD INT']]: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('ssd2')}
                                />
                                {/* os int(11) */}
                                <Select
                                    label="OS"
                                    description="Optional"
                                    placeholder="Select OS"
                                    data={getPCComponentQuery?.data?.OS ? [{label: 'None', value: ''},...getPCComponentQuery?.data?.OS]: []}
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    searchable
                                    {...form.getInputProps('os')}
                                />
                                {/* priceAdmin int(11) */}
                                <TextInput
                                    label="Selling Price (RM)"
                                    placeholder="0.00"
                                    disabled={getPCComponentQuery.isLoading || updateBuildMutation.isLoading}
                                    {...form.getInputProps('priceAdmin')}
                                />
                                <Group justify="flex-end" mt="md">
                                    <Button type="submit" loading={updateBuildMutation.isLoading}>Save Build</Button>
                                </Group>
                            </Stack>
                            </form>
                            </Skeleton>
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Box>
        </div>
    </div>
  );
}

export default BuildConfigUpdate;
